/* Léa — size guide drawer.
 *
 * Ported from Club 1984's. Two things it gets right and this keeps: inches are
 * derived from the cm already in the markup rather than stored a second time,
 * and the highlighted column follows the size the shopper is actually on rather
 * than whatever was selected when the page rendered.
 */
(function () {
  const drawer = () => document.querySelector('[data-lea-size-guide]');

  function open() {
    const el = drawer();
    if (!el) return;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    const close = el.querySelector('[data-lea-sg-close]');
    if (close) close.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    const el = drawer();
    if (!el) return;
    el.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }

  function onKey(event) {
    if (event.key === 'Escape') close();
  }

  function setUnit(unit) {
    const el = drawer();
    if (!el) return;

    el.querySelectorAll('[data-lea-sg-unit]').forEach((button) => {
      const on = button.dataset.leaSgUnit === unit;
      button.classList.toggle('lea-sg__unit--on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    el.querySelectorAll('td[data-cm]').forEach((cell) => {
      const cm = parseFloat(cell.dataset.cm);
      if (Number.isNaN(cm)) return;
      cell.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : String(cm);
    });
  }

  function boot() {
    const el = drawer();
    if (!el) return;

    // The panel is fixed, and the buy column it renders inside is sticky, which
    // would resolve the fixed position against that column instead of the
    // viewport. Reparent once.
    if (el.parentElement !== document.body) document.body.appendChild(el);

    el.querySelectorAll('[data-lea-sg-close]').forEach((b) => b.addEventListener('click', close));
    el.querySelectorAll('[data-lea-sg-unit]').forEach((b) =>
      b.addEventListener('click', () => setUnit(b.dataset.leaSgUnit))
    );

    // The set builder is the size control on this theme, so the chart follows it.
    const syncSize = (label) => {
      const key = String(label || '').trim().toLowerCase();
      if (!key) return;
      el.querySelectorAll('[data-size]').forEach((cell) => {
        cell.classList.toggle('lea-sg__col--on', cell.dataset.size === key);
      });
    };

    document.addEventListener('click', (event) => {
      const chip = event.target.closest('.lea-set__size');
      if (chip) syncSize(chip.textContent);
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-lea-sg-open], a[href="#fit-finder"], a[href="#size-guide"]');
      if (!trigger) return;
      event.preventDefault();
      open();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
